export type TransactionSourceDTO =
  (typeof TransactionSourceDTO)[keyof typeof TransactionSourceDTO];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionSourceDTO = {
  portal: 'portal',
  allpay: 'allpay',
  walletcard: 'walletcard',
  'alltix-resellers': 'alltix-resellers',
  'alltix-resellers-portal': 'alltix-resellers-portal',
} as const;
